import { useEffect, useMemo } from "react";

import { useFlocknoteAppState } from "Flocknote/state";

import useUrlParams from "Utilities/Hooks/useUrlParams";
import { useAddUrlParam } from "Utilities/urlParamHooks";

const useRedirectToValidTab = () => {
  const [{ availableProfileTabs = [] }] = useFlocknoteAppState();
  const { profileTab } = useUrlParams();
  const addUrlParam = useAddUrlParam();

  const profileTabIsValid = useMemo(() => {
    if (!availableProfileTabs?.length || !profileTab) return true;
    return availableProfileTabs.some(({ action }) => action === profileTab);
  }, [availableProfileTabs, profileTab]);

  const defaultTab = availableProfileTabs?.[0]?.action || "newsfeed";

  useEffect(() => {
    if (!profileTabIsValid) {
      console.warn(
        `"${profileTab}" is not available to this user. Redirecting to "${defaultTab}"`
      );
      window.fnReactBus.navigateToProfileTab(defaultTab);
      addUrlParam("profileTab", defaultTab);
    }
  });
};

export { useRedirectToValidTab };
